export default __webpack_public_path__ + "static/media/ic-students.24ac7b08.svg";